export default {
    marcacoes: {
      SemNada: {
        id: 0,
        cor: null,
        conversas: [
            { id: 134, name: "Tiaguinho", contactId: 103 },
            { id: 122, name: "Olailson", contactId: 215 },
            { id: 202, name: "Ketleyn", contactId: 296 },
        ]
      },
      Importante: {
        id: 1,
        cor: "#FF5733",
        conversas: [
          { id: 1, name: "Iago", contactId: 10 },
          { id: 12, name: "Amanda", contactId: 21 },
          { id: 20, name: "Giovanna", contactId: 29 },
        ],
      },
      Trabalho: {
        id: 2,
        cor: "#3498DB",
        conversas: [
          { id: 2, name: "Ana", contactId: 11 },
          { id: 13, name: "Henrique", contactId: 22 },
        ],
      },
      Estudo: {
        id: 3,
        cor: "#27AE60",
        conversas: [
          { id: 5, name: "Pedro", contactId: 14 },
          { id: 15, name: "Vinícius", contactId: 24 },
        ],
      },
      Lazer: {
        id: 4,
        cor: "#E74C3C",
        conversas: [
          { id: 7, name: "Fernando", contactId: 16 },
          { id: 16, name: "Carolina", contactId: 25 },
        ],
      },
      Urgente: {
        id: 5,
        cor: "#FFC300",
        conversas: [
          { id: 8, name: "Camila", contactId: 17 },
          { id: 17, name: "Diego", contactId: 26 },
        ],
      },
      Pessoal: {
        id: 6,
        cor: "#8E44AD",
        conversas: [
          { id: 10, name: "Isabela", contactId: 19 },
          { id: 18, name: "Beatriz", contactId: 27 },
        ],
      },
      Pessoal: {
        id: 6,
        cor: "#8E44AD",
        conversas: [
          { id: 10, name: "Isabela", contactId: 19 },
          { id: 18, name: "Beatriz", contactId: 27 },
        ],
      },
      TESTE: {
        id: 6,
        cor: "#8E44AD",
        conversas: [
          { id: 10, name: "Isabela", contactId: 19 },
          { id: 18, name: "Beatriz", contactId: 27 },
        ],
      },
      OUTRO: {
        id: 6,
        cor: "#8E44AD",
        conversas: [
          { id: 10, name: "Isabela", contactId: 19 },
          { id: 18, name: "Beatriz", contactId: 27 },
        ],
      },
    },
  };